import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

const root = document.getElementById('root');

// react-snap pre-renderiza o HTML — usa hydrateRoot para reidratar sem re-render.
// Em desenvolvimento (ou primeira carga sem snap), usa createRoot normalmente.
if (root.hasChildNodes()) {
  ReactDOM.hydrateRoot(root, <App />);
} else {
  ReactDOM.createRoot(root).render(<App />);
}
